//@ts-nocheck
import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  includeExpired: false,
  additionalFilters: "notSet",
  sortBy: 'dateCreated',
  queryKey: ['directs'],
  queryOptions: {},
};

const getAllDirects = async (queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const { data } = await axios.get(`/api/directs?${queryString}`);

  return data;
};

export const useDirects = (queryParams = {}) => {
  const { queryKey, queryOptions, page, limit, search, includeInactive, acceptingOffers, additionalFilters, sortBy  } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    includexpired: !acceptingOffers,
    additionalfilters: additionalFilters,
    sortby: sortBy,
    offset: page * limit,
  };

  return useQuery([...queryKey], () => getAllDirects(queryStringParams), {
    select: ({ data: directs, total }) => ({ directs, total }),
    initialData: {
      directs: [],
      total: 0,
    },
    ...queryOptions,
  });
};
